"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var storageKeys = {
    DATA_LAYER: '.dataLayer',
    EVENT_CONFIGURATION: '.eventConfiguration',
    REGISTERED_EVENT_MANAGERS: 'registeredEventManagers',
    SCHEMA: '.schema'
};
exports.default = storageKeys;
